import { apiClient } from "../../services/apiClient.js";

const API_BASE = import.meta.env.VITE_API_URL || "/api";

export async function listInspectionJobs(date) {
  return (await apiClient.get("/inspection/jobs", { params: { date } })).data;
}

export async function getInspectionJob(inspectionId) {
  return (await apiClient.get(`/inspection/jobs/${inspectionId}`)).data;
}

// Everything on the printed job sheet — its own request, so the day's list and the
// photo screen stay light.
export async function getInspectionJobSheet(inspectionId) {
  return (await apiClient.get(`/inspection/jobs/${inspectionId}/sheet`)).data;
}

// Finishing records the visit; the office moves the claim to Inspected.
//
// dateInspected is sent by the DEVICE, not left to the server: a finish recorded
// in a dead spot is sent when the phone next has signal, which can be the next
// morning, and the visit happened on the day the inspector tapped the button.
// pendingUploadIds is the queue identities this job still has on the device, so
// the office can see how many photos are still coming. Ids rather than a count:
// one that has already landed cannot then be counted as missing
// (services/inspection/jobs.js).
export async function finishInspectionJob(
  inspectionId,
  { dateInspected = null, pendingUploadIds = null } = {}
) {
  return (await apiClient.post(`/inspection/jobs/${inspectionId}/finish`, {
    date_inspected: dateInspected,
    pending_upload_ids: pendingUploadIds,
  })).data;
}

export async function reopenInspectionJob(inspectionId) {
  return (await apiClient.post(`/inspection/jobs/${inspectionId}/reopen`)).data;
}

// What the inspector wants the office to read. Its own field, never the office's
// own notes column (services/inspection/jobs.js).
export async function saveInspectorNotes(inspectionId, notes) {
  return (await apiClient.put(`/inspection/jobs/${inspectionId}/notes`, { notes })).data;
}

export async function listInspectionPhotos(inspectionId) {
  return (await apiClient.get(`/inspection/jobs/${inspectionId}/photos`)).data;
}

export async function uploadInspectionPhoto(inspectionId, record, onUploadProgress) {
  const form = new FormData();
  // Multer exposes text fields reliably when they precede the file part.
  form.append("client_upload_id", record.id);
  form.append("captured_at", record.capturedAt);
  form.append(
    "photo",
    new File([record.blob], record.filename, { type: record.contentType || record.blob.type })
  );
  return (await apiClient.post(`/inspection/jobs/${inspectionId}/photos`, form, {
    onUploadProgress,
  })).data;
}

export async function deleteInspectionPhoto(inspectionId, fileId) {
  return (await apiClient.delete(`/inspection/jobs/${inspectionId}/photos/${fileId}`)).data;
}

export function inspectionPhotoContentUrl(inspectionId, fileId) {
  return `${API_BASE}/inspection/jobs/${inspectionId}/photos/${fileId}/content`;
}
